/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconInfoBlue = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--infoblue',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"{...rest}><g fill="none" fillRule="evenodd"><path className="path1" d="M-2-2h24v24H-2z"/><path className="path2" fill="#5ABAEA" fillRule="nonzero" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9V9h2v6zm0-8H9V5h2v2z"/></g></IconBase>
  )
}

IconInfoBlue.propTypes = {
  className: PropTypes.string,
}

export default IconInfoBlue
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconInfoBlue.js